var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"justify":"center"}},[_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-img',_vm._g({attrs:{"src":_vm.logo,"max-height":"45","max-width":"45"}},on))]}}])},[_vm._v(" "+_vm._s(_vm.nombreCategoria)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }